// extracted by mini-css-extract-plugin
module.exports = {"main":"root-page_main__Sj0oB","content":"root-page_content__W0Rg2","title":"root-page_title__XEtAx"};